module.exports = function (cT6) {
  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(cT6);
};